module.exports = __webpack_public_path__ + "img/sec2desk.93944861.png";